import { Record, RecordOf } from 'immutable';



export type AuthInfo = RecordOf<AuthInfoProperties>;


export interface AuthInfoProperties {
  email: string;
  password: string;
  phoneNumber: string;
  rememberUsername: boolean;
  secretAnswer: string;
  secretQuestion: string;
  status: string;
  username: string;
  otp: string;
  verificationMethod: string;
  skip2fvSetUp: boolean;
  isEncoded: boolean;
}


export class AuthInfoFactory {
  static readonly create = Record<AuthInfoProperties>({
    email: null,
    password: null,
    phoneNumber: null,
    rememberUsername: false,
    secretAnswer: null,
    secretQuestion: null,
    status: null,
    username: null,
    otp: null,
    verificationMethod: null,
    skip2fvSetUp: false,
    isEncoded: false
  });
}
